import { useState } from 'react';
import Field from '../../components/Field.jsx';
import Alert from '../../components/ui/Alert.jsx';
import Modal, { ModalActions } from '../../components/ui/Modal.jsx';

/**
 * One-field modal for naming something: add a brand, rename the company, rename a brand.
 * onSave(name) may be async and throw; field errors come back as err.data.fields.name.
 */
export default function NameModal({ title, description, label, initial = '', submitLabel, placeholder, onClose, onSave }) {
  const [name, setName] = useState(initial);
  const [error, setError] = useState('');
  const [fieldError, setFieldError] = useState('');
  const [busy, setBusy] = useState(false);

  const save = async () => {
    if (!name.trim()) { setFieldError(`Enter the ${label.toLowerCase()}.`); return; }
    setBusy(true); setError(''); setFieldError('');
    try {
      await onSave(name.trim());
    } catch (err) {
      if (err.data?.fields?.name) setFieldError(err.data.fields.name); else setError(err.message);
      setBusy(false);
    }
  };

  return (
    <Modal title={title} description={description} onClose={onClose} onSubmit={save} busy={busy} size="sm"
      footer={<ModalActions submitLabel={submitLabel} busy={busy} onCancel={onClose} />}>
      {error && <Alert tone="danger">{error}</Alert>}
      <Field label={label} value={name} onChange={(e) => { setName(e.target.value); setFieldError(''); }}
        error={fieldError} placeholder={placeholder} maxLength={200} />
    </Modal>
  );
}
